<div class="dynamic-breadcrumbs-wrapper" *ngIf="breadcrumbs$ | async as chunks">
  <ng-container *ngFor="let chunk of chunks; let first = first; let last = last">
    <span
      class="dynamic-breadcrumbs-text"
      [ngClass]="{ 'dynamic-breadcrumbs-last': (last && !first) || last }"
      (click)="goToLink(chunk.route)"
      *ngIf="chunk.displayName; else singleChunkBlock"
      >{{ chunk.displayName }}
      <span *ngIf="!last">/</span>
    </span>

    <ng-template #singleChunkBlock>
      <span class="dynamic-breadcrumbs-text" [ngClass]="{ 'dynamic-breadcrumbs-last': (last && !first) || last }">
        {{ chunk }}
      </span>
    </ng-template>
  </ng-container>
</div>
